import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore
const Entities = () => import('@/entities/entities.vue');

// prettier-ignore

const NuevaSolicitud = () => import('@/entities/reniecytMs/solicitudes/nueva-solicitud/nueva-solicitud.vue');
const ConsultaSolicitudes = () => import('@/entities/reniecytMs/solicitudes/consulta-solicitud/consulta-solicitudes.vue');
const ConsultaSubsedes = () => import('@/entities/reniecytMs/solicitudes/consulta-subsede/consulta-subsedes.vue');
const ConsultaSubsedesRev = () => import('@/entities/reniecytMs/solicitudes/consulta-subsede-rev/consulta-subsedes-rev.vue');
const SeleccionaRol = () => import('@/entities/reniecytMs/selecciona-rol/selecciona-rol.vue');
const SolicitudMoral = () => import('@/entities/reniecytMs/solicitud-moral/solicitud-moral.vue');
const DatosGenerales = () => import('@/entities/reniecytMs/datos-generales/datos-generales.vue');
const DomicilioFiscal = () => import('@/entities/reniecytMs/solicitud-moral/domicilio-fiscal/domicilio-fiscal.vue');
const RepresentanteSede = () => import('@/entities/reniecytMs/solicitud-moral/representante-sede/representante-sede.vue');
const DocumentoCreacionComponent = () => import('@/entities/reniecytMs/solicitud-moral/documento-creacion/documento-creacion.vue');
const Documentos = () => import('@/entities/reniecytMs/solicitud-fisica/documentos/documentos.vue');
const SolicitudFisica = () => import('@/entities/reniecytMs/solicitud-fisica/solicitud-fisica.vue');
const DomicilioResidenciaFisica = () => import('@/entities/reniecytMs/solicitud-fisica/domicilio-residencia/domicilio-residencia.vue');
const MediosContactoFisica = () => import('@/entities/reniecytMs/solicitud-fisica/medios-contacto/medios-contacto.vue');
const AddPoderOtorgado = () => import('@/entities/reniecytMs/solicitud-moral/representante-sede/poder-otorgado/add-poder-otorgado.vue');
const SubsedesComponent = () => import('@/entities/reniecytMs/solicitud-moral/subsedes/subsedes.vue');
const ConsultaRegistros = () => import('@/entities/reniecytMs/solicitudes/consulta-registros/consulta-registros.vue');
const ConsultaRegistrosAdmin = () => import('@/entities/reniecytMs/solicitudes/consulta-registros-admin/consulta-registros-admin.vue');
const Reportes = () => import('@/entities/reniecytMs/reportes/reportes.vue');
const ConsultaRegistrosOperativo = () =>
  import('@/entities/reniecytMs/solicitudes/consulta-registros-operativo/consulta-registros-operativo.vue');
const ListaDocumentos = () => import('@/entities/reniecytMs/solicitud-moral/lista-documentos/lista-documentos.vue');
const RegistroAnotacionesIncumplimiento = () =>
  import('@/entities/reniecytMs/anotaciones-incumplimiento/registro-anotaciones-incumplimiento.vue');
const CancelacionRegistroAnotacionesIncumplimiento = () =>
  import('@/entities/reniecytMs/anotaciones-incumplimiento/cancelacion-registro-anotaciones-incumplimiento.vue');
const RegistrosIncumplimientos = () => import('@/entities/reniecytMs/anotaciones-incumplimiento/registros-incumplimientos.vue');
const InformacionSubsede = () =>
  import('@/entities/reniecytMs/solicitudes/consulta-subsede-rev/informacion-subsede/informacion-subsede.vue');
// jhipster-needle-add-entity-to-router-import - JHipster will import entities to the router here

export default {
  path: '/',
  component: Entities,
  children: [
    {
      path: '/solicitud',
      name: 'ConsultaSolicitudes',
      component: ConsultaSolicitudes,
    },
    {
      path: '/subsedes',
      name: 'ConsultaSubsedes',
      component: ConsultaSubsedes,
    },
    {
      path: '/solicitud/registro',
      name: 'NuevaSolicitud',
      component: NuevaSolicitud,
    },
    {
      path: '/solicitud/registro-edicion/',
      name: 'EdicionSolicitud',
      component: NuevaSolicitud,
    },
    {
      path: '/selecciona-rol',
      name: 'SeleccionaRol',
      component: SeleccionaRol,
    },
    {
      path: '/solicitud/datos-generales', //Para Moral, fisica y representante
      name: 'DatosGenerales',
      component: DatosGenerales,
    },
    {
      path: '/solicitud/moral/',
      name: 'SolicitudMoral',
      component: SolicitudMoral,
    },
    {
      path: '/solicitud/domicilio-fiscal', //Para persona moral , fisica pero no para representante, y el idPErsona solo es para fiscal
      name: 'DomicilioFiscal',
      component: DomicilioFiscal,
    },
    {
      path: '/solicitud/representante-sede/',
      name: 'RepresentanteSede',
      component: RepresentanteSede,
    },
    {
      path: '/solicitud/documento-creacion',
      name: 'DocumentoCreacion',
      component: DocumentoCreacionComponent,
    },
    {
      path: '/solicitud/documentos/',
      name: 'DocumentosMoral',
      component: Documentos,
    },
    {
      path: '/solicitud/documentos/',
      name: 'DocumentosFisica',
      component: Documentos,
    },
    {
      path: '/solicitud/fisica/documentos/add',
      name: 'AddDocumentosFisica',
      component: Documentos,
    },
    {
      path: '/solicitud/fisica/', //id Persona no existe en flujo de revisor, se obtiene de manera interna el id
      name: 'SolicitudFisica',
      component: SolicitudFisica,
    },
    {
      path: '/solicitud/domicilio-residencia', //Para persona fisica y representante
      name: 'DomicilioResidenciaFisica',
      component: DomicilioResidenciaFisica,
    },
    {
      path: '/solicitud/fisica/medios-contacto', //Para persona fisica y representante
      name: 'MediosContactoFisica',
      component: MediosContactoFisica,
    },
    {
      path: '/solicitud/moral/representante-sede/poder-otorgado/add', //Flujo solo para representante todo obligatorio
      name: 'AddPoderOtorgado',
      component: AddPoderOtorgado,
    },
    {
      path: '/registro/subsedes/',
      name: 'Subsedes',
      component: SubsedesComponent,
    },
    {
      path: '/consulta-registros-revisor',
      name: 'ConsultaRegistros',
      component: ConsultaRegistros,
      meta: { authorities: [Authority.OPERATIVO_RENIECYT] },
    },
    {
      path: '/consulta-subsedes-revisor',
      name: 'ConsultaSubsedesRev',
      component: ConsultaSubsedesRev,
      meta: { authorities: [Authority.OPERATIVO_RENIECYT] },
    },
    {
      path: '/consulta-registros-admin',
      name: 'ConsultaRegistrosAdmin',
      component: ConsultaRegistrosAdmin,
      meta: { authorities: [Authority.DIRECCION_RENIECYT] },
    },
    {
      path: '/reportes',
      name: 'Reportes',
      component: Reportes,
      meta: { authorities: [Authority.OPERATIVO_RENIECYT] },
    },
    {
      path: '/consulta-registros-operativo',
      name: 'ConsultaRegistrosOperativo',
      component: ConsultaRegistrosOperativo,
      meta: { authorities: [Authority.OPERATIVO_CONSULTA_RENIECYT] },
    },
    {
      path: '/lista-documentos/',
      name: 'ListaDocumentos',
      component: ListaDocumentos,
    },
    {
      path: '/anotaciones-incumplimiento',
      name: 'RegistroAnotacionesIncumplimiento',
      component: RegistroAnotacionesIncumplimiento,
      meta: { authorities: [Authority.ROLE_REGISTRO_ANOTACIONES] },
    },
    {
      path: '/registros-incumplimientos',
      name: 'RegistrosIncumplimientos',
      component: RegistrosIncumplimientos,
      meta: { authorities: [Authority.ROLE_REGISTRO_ANOTACIONES] },
    },
    {
      path: '/cancelacion-anotaciones-incumplimiento',
      name: 'CancelacionRegistroAnotacionesIncumplimiento',
      component: CancelacionRegistroAnotacionesIncumplimiento,
      meta: { authorities: [Authority.ROLE_REGISTRO_ANOTACIONES] },
    },
    {
      path: '/subsede/informacion/',
      name: 'InformacionSubsede',
      component: InformacionSubsede,
    },
  ],
};
